@if (!viewOnly()) {
  <div
    [formGroup]="formGroup"
    class="tel-input-container flex flex-col w-full"
    [class.cursor-not-allowed]="disabled()"
    [class.has-errors]="childControl.touched && childControl.errors">
    <label
      class="block text-sm mb-x-sm"
      [class.label-required]="required()"
      [class.text-neutral-900]="!disabled()"
      [class.font-medium]="!disabled()"
      [class.text-neutral-300]="disabled()"
      [class.cursor-not-allowed]="disabled()">
      {{ label() }}
    </label>

    <div class="relative">
      <ngx-intl-tel-input
        (ngModelChange)="onInputValueChange($event)"
        [cssClass]="
          'tel-input' +
          (childControl.errors && childControl.touched
            ? ' tel-invalid has-errors'
            : '')
        "
        [enableAutoCountrySelect]="false"
        [enablePlaceholder]="true"
        [customPlaceholder]="displayPlaceholder()"
        [searchCountryFlag]="true"
        [searchCountryField]="[
          SearchCountryField.Name,
          SearchCountryField.DialCode,
          SearchCountryField.Iso2,
        ]"
        [preferredCountries]="['sa', 'eg']"
        [required]="required()"
        [selectFirstCountry]="true"
        [selectedCountryISO]="selectedCountryISO"
        [phoneValidation]="true"
        [separateDialCode]="true"
        [searchCountryPlaceholder]="searchPlaceholder()"
        [inputId]="id()"
        name="name()"
        [formControlName]="'phone'" />
    </div>
  </div>
} @else {
  <div class="flex flex-col">
    <label class="text-neutral-500 font-medium text-xs2">
      {{ label() }}
    </label>

    <p class="font-semibold text-xs text-neutral-900">
      <span dir="ltr">
        {{
          viewValue() ? viewValue() : ('details_not_found_label' | transloco)
        }}
      </span>
    </p>
  </div>
}
